import { render, staticRenderFns } from "./CoPlanList.vue?vue&type=template&id=07e70a4c&scoped=true&"
import script from "./CoPlanList.vue?vue&type=script&lang=ts&"
export * from "./CoPlanList.vue?vue&type=script&lang=ts&"
import style0 from "./CoPlanList.vue?vue&type=style&index=0&id=07e70a4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e70a4c",
  null
  
)

export default component.exports